export const PAGE_LIMIT = 100
export const DROP_DOWN_LIST_LIMIT = 7

export enum RESPONSE {
   UPDATED_VISABILITY = 'UPDATED_VISABILITY',
   REMOVED_ALL = 'REMOVED_ALL',
   REMOVED = 'REMOVED'
}
